import { AfterViewInit, Directive, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]',
})
export class AutoFocusDirective implements AfterViewInit {
  private el = inject(ElementRef);

  readonly appAutoFocus = input<boolean>(true);

  ngAfterViewInit() {
    if (!this.appAutoFocus()) {
      return;
    }

    setTimeout(() => {
      this.el.nativeElement.focus();
    }, 0);
  }
}
